import styled from "@emotion/styled";
import { mediaQueries } from "@stepfinance/react";
import { Col, Row } from "antd";
import React from "react";

import StepDisconnectedLogo from "../../assets/step-disconnected-logo.svg";
import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useLanguageContext } from "../../contexts/language/language";

const CenteredBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;

  div {
    margin: 0 auto;
    text-align: center;
    width: 262px;
    img {
      width: 160px;
    }
    ${mediaQueries[1]} {
      width: 546px;
    }
    ${mediaQueries[3]} {
      width: 546px;
    }
  }
`;

const Instructions = styled.div`
  padding-top: 40px;
  span {
    font-weight: normal;
    font-size: 20px;
    line-height: 26px;
  }
`;

export const ConnectView: React.FC = () => {
  const { connecting } = useEnrichedWallet();

  // This is an example of utilizing the LanguageContext in the app. Our implementations should look similar to this.
  const {
    currentLanguageData: {
      pages: {
        allPages: { connectView },
      },
    },
  } = useLanguageContext();
  const instructionMessage = connecting ? connectView.connecting : connectView.connectWallet;

  return (
    <Row align="middle">
      <Col span={24}>
        <CenteredBox>
          <div>
            <img src={StepDisconnectedLogo} alt="Step graphic" />
            <Instructions>
              <span>{instructionMessage}</span>
            </Instructions>
          </div>
        </CenteredBox>
      </Col>
    </Row>
  );
};
